import ModalComponent from '../../../../shared/components/Modals/ModalComponent'
import ModalBody from '../../../../shared/components/Modals/ModalBody'
import icon from "../../../../shared/assets/images/bookDemoSuccessIcon.svg";
import { Button } from 'antd';
import { selectIsThanksModalOpen, setIsThanksModalOpen } from '../../../ContactUsForm/slice/contactusSlice';
import { useDispatch, useSelector } from 'react-redux';
// for demo only 
function ThanksModal() { 
    const dispatch = useDispatch()
    const isOpen = useSelector(selectIsThanksModalOpen)
    return (
        <ModalComponent
            handleCloseModal={() => dispatch(setIsThanksModalOpen(!isOpen))}
            visibleModal={isOpen}
            width={464}
            content={
                <ModalBody
                    icon={icon}
                    title="Thanks for your interest!"
                    subtitle="Our sales team will reach out shortly to help you get started and answer any questions about your plan."
                >
                    <Button className='w-full pt-2 pb-8 font-medium btn-primary' htmlType="submit" onClick={() => dispatch(setIsThanksModalOpen(!isOpen))}>
                        Ok
                    </Button>
                </ModalBody>
            }
        />
    )
}

export default ThanksModal